module.exports = __webpack_public_path__ + "img/4_lnd.ee8f3cf8.jpg";